import { render, staticRenderFns } from "./VueTeam.vue?vue&type=template&id=d65093f8&scoped=true&"
import script from "./VueTeam.vue?vue&type=script&lang=js&"
export * from "./VueTeam.vue?vue&type=script&lang=js&"
import style0 from "./VueTeam.vue?vue&type=style&index=0&id=d65093f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65093f8",
  null
  
)

component.options.__file = "VueTeam.vue"
export default component.exports